module.exports = __webpack_public_path__ + "static/img/news21_3.927f8e0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news21_3.jpeg
// module id = bdkj
// module chunks = 0